import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ModalContent from "./modalContent";
import * as CONSTANTS from "./constants";

class Modal extends React.Component {
  render() {
    if (!this.props.show) {
      return null;
    }

    const modalClasses = classNames("modal", this.props.className);

    return (
      <div className={modalClasses}>
        <ModalContent
          type={this.props.type}
          width={this.props.width}
          height={this.props.height}
          title={this.props.title}
          footer={this.props.footer}
          noCloseOnClickOutside={this.props.noCloseOnClickOutside}
          yesTitle={this.props.yesTitle}
          yesHandlerOnClick={this.props.yesHandlerOnClick}
          yesThemeButton={this.props.yesThemeButton}
          yesDisabled={this.props.yesDisabled}
          noTitle={this.props.noTitle}
          noHandlerOnClick={this.props.noHandlerOnClick}
          noThemeButton={this.props.noThemeButton}
        >
          {this.props.children}
        </ModalContent>
      </div>
    );
  }
}

Modal.defaultProps = {
  type: CONSTANTS.YES_NO,
  show: false,
  title: null,
  width: null,
  height: null,
  footer: null,
  noCloseOnClickOutside: false,
  children: null
};

Modal.propTypes = {
  type: PropTypes.oneOf([CONSTANTS.YES_NO, CONSTANTS.ALERT]),
  show: PropTypes.bool,
  title: PropTypes.string,
  width: PropTypes.oneOf(["normal", "xs", "sm", "md", "lg", "full"]),
  height: PropTypes.oneOf(["full"]),
  footer: PropTypes.node,

  noCloseOnClickOutside: PropTypes.bool,

  yesTitle: PropTypes.string,
  yesHandlerOnClick: PropTypes.func,
  yesThemeButton: PropTypes.string,
  yesDisabled: PropTypes.bool,

  noTitle: PropTypes.string,
  noHandlerOnClick: PropTypes.func,
  noThemeButton: PropTypes.string,

  children: PropTypes.node
};

export default Modal;
